import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSpeakerOnLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14 2H15C15 1.60762 14.7705 1.2515 14.4132 1.08937C14.0559 0.927231 13.6368 0.989041 13.3415 1.24742L14 2ZM6 9V10C6.24222 10 6.47621 9.91208 6.6585 9.75258L6 9ZM1 9V8C0.447715 8 0 8.44772 0 9H1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM6 15L6.6585 14.2474C6.47621 14.0879 6.24222 14 6 14V15ZM14 22L13.3415 22.7526C13.6368 23.011 14.0559 23.0728 14.4132 22.9106C14.7705 22.7485 15 22.3924 15 22H14ZM20.5935 5.69517C20.149 5.36739 19.523 5.462 19.1952 5.90649C18.8674 6.35099 18.962 6.97704 19.4065 7.30483L20.5935 5.69517ZM23 12.6899L22.0005 12.6572L22.0001 12.6698L22 12.6824L23 12.6899ZM19.3195 18.7672C18.9148 19.1431 18.8914 19.7758 19.2672 20.1805C19.6431 20.5852 20.2758 20.6086 20.6805 20.2328L19.3195 18.7672ZM18.0068 8.63793C17.5307 8.35804 16.9178 8.5171 16.6379 8.99321C16.358 9.46932 16.5171 10.0822 16.9932 10.3621L18.0068 8.63793ZM16.9932 15.6379C16.5171 15.9178 16.358 16.5307 16.6379 17.0068C16.9178 17.4829 17.5307 17.642 18.0068 17.3621L16.9932 15.6379ZM13.3415 1.24742L5.3415 8.24742L6.6585 9.75258L14.6585 2.75258L13.3415 1.24742ZM6 8H1V10H6V8ZM0 9V15H2V9H0ZM1 16H6V14H1V16ZM5.3415 15.7526L13.3415 22.7526L14.6585 21.2474L6.6585 14.2474L5.3415 15.7526ZM15 22V2H13V22H15ZM19.4065 7.30483C20.2405 7.91983 20.9124 8.72834 21.3643 9.66074L23.164 8.78848C22.5707 7.56416 21.6884 6.50261 20.5935 5.69517L19.4065 7.30483ZM21.3643 9.66074C21.8162 10.5932 22.0345 11.6215 22.0005 12.6572L23.9995 12.7227C24.0441 11.363 23.7574 10.0128 23.164 8.78848L21.3643 9.66074ZM22 12.6824C21.9914 13.8258 21.7492 14.9553 21.2882 16.0016L23.1185 16.8079C23.6893 15.5122 23.9893 14.1134 24 12.6975L22 12.6824ZM21.2882 16.0016C20.8273 17.048 20.1573 17.9892 19.3195 18.7672L20.6805 20.2328C21.7181 19.2692 22.5477 18.1037 23.1185 16.8079L21.2882 16.0016ZM16.9932 10.3621C17.4527 10.6322 17.8337 11.0177 18.0984 11.4805L19.8344 10.4873C19.3967 9.72223 18.7667 9.08468 18.0068 8.63793L16.9932 10.3621ZM18.0984 11.4805C18.3632 11.9432 18.5024 12.467 18.5024 13H20.5024C20.5024 12.1185 20.2721 11.2524 19.8344 10.4873L18.0984 11.4805ZM18.5024 13C18.5024 13.533 18.3632 14.0568 18.0984 14.5195L19.8344 15.5127C20.2721 14.7476 20.5024 13.8815 20.5024 13H18.5024ZM18.0984 14.5195C17.8337 14.9823 17.4527 15.3678 16.9932 15.6379L18.0068 17.3621C18.7667 16.9153 19.3967 16.2778 19.8344 15.5127L18.0984 14.5195Z"
      fill={props.color}
    />
  </svg>
);

SvgSpeakerOnLarge.displayName = 'SvgSpeakerOnLarge';
const SpeakerOnLarge = withForgeIconProps(SvgSpeakerOnLarge, {
  name: 'SpeakerOn',
  usage: 'Use to indicate audio, or to mute audio.',
  related: 'speaker, sound, volume',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default SpeakerOnLarge;
